/**
 * ████████╗ ██████╗ ██╗     ██╗███╗   ██╗ ██████╗
 * ╚══██╔══╝██╔═══██╗██║     ██║████╗  ██║██╔═══██╗
 *    ██║   ██║   ██║██║     ██║██╔██╗ ██║██║   ██║
 *    ██║   ██║   ██║██║     ██║██║╚██╗██║██║   ██║
 *    ██║   ╚██████╔╝███████╗██║██║ ╚████║╚██████╔╝
 *    ╚═╝    ╚═════╝ ╚══════╝╚═╝╚═╝  ╚═══╝ ╚═════╝
 *
 * (c) Copyright 2021-present Rakuten Kobo Inc. (https://www.kobo.com)
 */

// -----------------------------------------------------------------------------
// IMPORTS
// -----------------------------------------------------------------------------

// Internal dependencies
import color from "./color-palette";

// -----------------------------------------------------------------------------
// DEFAULT COLORS
// -----------------------------------------------------------------------------

const COLORS_DEFAULT = {

  // Named color definitions shared by all themes
  black:               color.black,
  black12:             color.black12,
  black14:             color.black14,
  black16:             color.black16,
  black20:             color.black20,
  black42:             color.black42,
  gray:                color.white24,
  transparent:         color.transparent,
  white:               color.white,
  red:                 color.red,
  blue:                color.blue,
  yellow:              color.yellow,

  //highlight colors
  highlightYellowLight:   "#F6F3B3",             //rgb(246,243,179)
  highlightBlueLight:   "#B2E1E8",               //rgb(178,225,232)
  highlightGreenLight:   "#C6E09E",              //rgb(198,224,158)
  highlightPinkLight:   "#E8AFCF",               //rgb(232,175,207)
  highlightYellowBgDark:   "#897A36",            //rgba(137,122,54,1)
  highlightBlueBgDark:   "#20707D",              //rgba(32,112,125,1)
  highlightGreenBgDark:   "#5B7B28",             //rgba(91,123,40,1)
  highlightPinkBgDark:   "#99537A",              //rgba(153,83,122,1)
  highlightYellowDark:   "#ADA789",              //rgb(173,167,137)
  highlightBlueDark:   "#82A1A6",                //rgb(130,161,166)
  highlightGreenDark:   "#9AA589",               //rgb(154,165,137)
  highlightPinkDark:   "#B999AB"                 //rgb(185,153,171)
  
};


// -----------------------------------------------------------------------------
// EXPORTS
// -----------------------------------------------------------------------------

export default COLORS_DEFAULT;
